import { formatCents } from "@budgeter/shared";
import { cn } from "./cn";

export interface MoneyProps {
  cents: number;
  signed?: boolean;
  /** Colour negatives red (account balances); budget pills use BalancePill instead. */
  tone?: "plain" | "negRed";
  className?: string;
}

export function Money({ cents, signed, tone = "plain", className }: MoneyProps) {
  return (
    <span className={cn("num", tone === "negRed" && cents < 0 && "text-neg", className)}>
      {formatCents(cents, { signed })}
    </span>
  );
}
